import { render, staticRenderFns } from "./data20.vue?vue&type=template&id=13858ccf&scoped=true&"
import script from "./data20.vue?vue&type=script&lang=js&"
export * from "./data20.vue?vue&type=script&lang=js&"
import style1 from "./data20.vue?vue&type=style&index=1&id=13858ccf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13858ccf",
  null
  
)

export default component.exports